import React from 'react';
import {FaPaintRoller} from 'react-icons/fa';

export function Painting({...rest}) {
  return <FaPaintRoller size={35} {...rest} />;
}
